import * as React from "react";
import { Control, useController } from "react-hook-form";
import TextField from "@mui/material/TextField";
import { AppointmentFormValues } from "../appointment-form.component";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import MenuItem from "@mui/material/MenuItem";
import { PHYSICIAN_REFERRAL } from "constants/appointments";

type ReferralFieldProps = {
  control: Control<AppointmentFormValues, object>;
};

export default function ReferralField({ control }: ReferralFieldProps) {
  const {
    field,
    formState: { errors },
  } = useController({
    name: "referral",
    control,
    rules: {
      required: "Physician referral is required",
    },
  });
  return (
    <TextField
      fullWidth
      select
      SelectProps={{
        IconComponent: ExpandMoreOutlinedIcon,
      }}
      label="Physician referral"
      required
      {...(Boolean(errors?.referral?.message)
        ? { error: true, helperText: errors?.referral?.message }
        : {})}
      {...field}
    >
      {PHYSICIAN_REFERRAL.getOptions().map(({ value, label }) => (
        <MenuItem key={`${value}_${label}`} value={value}>
          {label}
        </MenuItem>
      ))}
    </TextField>
  );
}
